"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JarvisWebHttpClient = exports.SchemaValidationError = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const axios_retry_1 = tslib_1.__importDefault(require("axios-retry"));
const ajv_1 = tslib_1.__importDefault(require("ajv"));
/**
 * Custom error that occurs when API data does not match the expected schema.
 */
class SchemaValidationError extends Error {
    constructor(message) {
        super(message);
        this.constructor = SchemaValidationError;
        Object.setPrototypeOf(this, SchemaValidationError.prototype);
        this.name = SchemaValidationError.name;
        this.message = message;
    }
}
exports.SchemaValidationError = SchemaValidationError;
/**
 * JarvisWebHttp is the Jarvis Wrapper Around Axios
 * Provides for error handling and retries.
 */
class JarvisWebHttpClient {
    /**
     * Initializes a new instance of the JarvisWebHttp class
     * @param config client configuration
     */
    constructor(config) {
        this.defaultRetries = 3;
        this.axiosInstance = axios_1.default.create();
        if (config) {
            this.defaultBaseURL = config.defaultBaseURL;
            this.defaultAuthProvider = config.defaultAuthProvider;
            if (config.defaultRetries) {
                this.defaultRetries = config.defaultRetries;
            }
        }
        axios_retry_1.default(this.axiosInstance, {
            retries: this.defaultRetries,
            retryDelay: axios_retry_1.default.exponentialDelay
        });
    }
    /**
     * request
     * @param options That specifies AuthProvider, Retry Amount, and Axios Request Configuration
     */
    request(options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let axiosRequestConfig = options;
            let baseURL = options.baseURL ? options.baseURL : this.defaultBaseURL;
            if (baseURL) {
                axiosRequestConfig.baseURL = typeof baseURL === 'function' ? yield baseURL() : baseURL;
            }
            let authProvider = this.defaultAuthProvider;
            if (options.authProvider) {
                authProvider = options.authProvider;
            }
            let retries = this.defaultRetries;
            if (options.retries || options.retries === 0) {
                retries = options.retries;
            }
            axiosRequestConfig['axios-retry'] = {
                retries: retries
            };
            let authHeaderSetByUs = false;
            if (authProvider) {
                axiosRequestConfig.headers = axiosRequestConfig.headers || {};
                // Don't set the Authorization header if it's already set in the request options
                if (typeof axiosRequestConfig.headers['Authorization'] === 'undefined') {
                    authHeaderSetByUs = true;
                    let accessToken = yield authProvider.getAccessToken();
                    axiosRequestConfig.headers['Authorization'] = 'Bearer ' + accessToken;
                }
            }
            try {
                return yield this.makeRequest(axiosRequestConfig);
            }
            catch (error) {
                // Any status codes that falls outside the range of 2xx cause this function to trigger
                if (authHeaderSetByUs && authProvider && error.response && error.response.status === 401) {
                    // Unauthorized. Try to refresh a token with the auth provider
                    let accessToken = yield authProvider.getAccessToken(true);
                    axiosRequestConfig.headers['Authorization'] = 'Bearer ' + accessToken;
                    return this.makeRequest(axiosRequestConfig);
                }
                throw error;
            }
        });
    }
    makeRequest(options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let response = yield this.axiosInstance.request(options);
            if ([200, 201, 202, 203].indexOf(response.status) != -1 &&
                options.validationSchema
                && !new ajv_1.default().validate(options.validationSchema, response.data)) {
                let requestMethod = "GET" || options.method;
                let message = requestMethod.toUpperCase() + " request for " + options.url + " response does not match validationSchema";
                throw new SchemaValidationError(message);
            }
            return response;
        });
    }
    get(options) { return this.request(Object.assign(options, { method: 'get' })); }
    put(options) { return this.request(Object.assign(options, { method: 'put' })); }
    head(options) { return this.request(Object.assign(options, { method: 'head' })); }
    post(options) { return this.request(Object.assign(options, { method: 'post' })); }
    patch(options) { return this.request(Object.assign(options, { method: 'patch' })); }
    options(options) { return this.request(Object.assign(options, { method: 'options' })); }
    delete(options) { return this.request(Object.assign(options, { method: 'delete' })); }
}
exports.JarvisWebHttpClient = JarvisWebHttpClient;
//# sourceMappingURL=jarvis-web-http-client.js.map